import {
  buildT9Index,
  parseRanks,
} from "@/lib/tool-kit/ciphers-misc/phone-keypad";
import { loadWordList } from "@/lib/tool-kit/vocabulary/anagram";
import { NGSL_URL } from "@/lib/tool-kit/word-knowledge/vocabulary-profile";

/**
 * The dictionary behind T9 decoding: the site's ENABLE word list for which words exist
 * and the New General Service List (NGSL 1.2, Browne, Culligan and Phillips, CC BY-SA 4.0)
 * for which are commonest. Both are static files fetched on the first decode and kept for
 * the life of the page. A failed fetch is forgotten, so the next try asks again.
 */

let index: Promise<Map<string, string[]>> | null = null;

async function fetchRanks(): Promise<Map<string, number>> {
  const response = await fetch(NGSL_URL);
  if (!response.ok) {
    throw new Error(`Frequency list returned ${response.status}`);
  }
  return parseRanks(await response.text());
}

export function loadT9Index(): Promise<Map<string, string[]>> {
  if (!index) {
    index = Promise.all([loadWordList(), fetchRanks()])
      .then(([words, ranks]) => buildT9Index(words, ranks))
      .catch((error: unknown) => {
        index = null;
        throw error;
      });
  }
  return index;
}
